import CompanyTableActions from '@/components/companies/CompanyTableActions.vue';
import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import type { Company } from '@/types';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<Company>[] = [
    {
        accessorKey: 'id',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.companies_table.id',
            }),
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'name',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.companies_table.name',
            }),
        sortingFn: 'text',
    },
    {
        accessorKey: 'cvr',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.companies_table.cvr',
            }),
    },
    {
        accessorKey: 'address',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.companies_table.address',
            }),
    },
    {
        accessorKey: 'economic_data.economic_number',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.companies_table.economic_number',
            }),
        filterFn: 'includesString',
    },
    {
        accessorKey: 'economic_data.customer_no',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.companies_table.economic_customer_number',
            }),
        filterFn: 'includesString',
    },
    {
        accessorKey: 'services.num_of_vouchers',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.companies_table.num_of_vouchers',
            }),
        cell: ({ row }) => {
            const value = row.original.services.num_of_vouchers;
            return value === 0 ? 'N/A' : value;
        },
        filterFn: 'inNumberRange',
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'services.fixed_price',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.companies_table.fixed_price',
            }),
        filterFn: 'inNumberRange',
        meta: {
            filterType: 'number',
        },
    },
    {
        accessorKey: 'vat_frequency_text',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.companies_table.vat_frequency',
            }),
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    },
    {
        accessorKey: 'update_frequency_text',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.companies_table.update_frequency',
            }),
        filterFn: 'arrIncludesSome',
        meta: {
            filterType: 'checkbox',
        },
    },
    {
        accessorKey: 'status',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'companies.companies_table.status',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                status: row.original.status,
                type: 'companyStatus',
            });
        },
        filterFn: 'boolean',
        meta: {
            filterType: 'companyStatus',
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(CompanyTableActions, {
                company: row.original,
            });
        },
    },
];
